import performRequest from "./perform-request";
import { sportCountriesPublicRoute } from "./api-routes";

const requests = {};

// The catalog never changes at runtime, so each locale is fetched once per page load.
export const fetchSportCountries = (lang) => {
  if (!requests[lang]) {
    requests[lang] = performRequest("GET", sportCountriesPublicRoute, { lang }, false)
      .then((response) => response.data.data ?? [])
      .catch((error) => {
        delete requests[lang];
        throw error;
      });
  }
  return requests[lang];
};
